import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-secondary/30">
      <div className="container-wide py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
                <span className="text-lg font-bold text-primary-foreground">SI</span>
              </div>
              <span className="font-display text-xl font-semibold">Silla Ideal</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Tu guía de confianza para encontrar la silla de escritorio perfecta. 
              Análisis ergonómicos para mejorar tu postura y productividad.
            </p>
          </div>

          {/* Categories */}
          <div>
            <p className="mb-4 font-display text-sm font-semibold">Categorías</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/categoria/sillas-ergonomicas" className="text-muted-foreground hover:text-foreground">
                  Sillas Ergonómicas
                </Link>
              </li>
              <li>
                <Link to="/categoria/sillas-gaming" className="text-muted-foreground hover:text-foreground">
                  Sillas Gaming
                </Link>
              </li>
              <li>
                <Link to="/categoria/sillas-ejecutivas" className="text-muted-foreground hover:text-foreground">
                  Sillas Ejecutivas
                </Link>
              </li>
              <li>
                <Link to="/categoria/sillas-economicas" className="text-muted-foreground hover:text-foreground">
                  Sillas Económicas
                </Link>
              </li>
              <li>
                <Link to="/categoria/sillas-dolor-lumbar" className="text-muted-foreground hover:text-foreground">
                  Sillas para Dolor Lumbar
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <p className="mb-4 font-display text-sm font-semibold">Recursos</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/productos" className="text-muted-foreground hover:text-foreground">
                  Todos los Productos
                </Link>
              </li>
              <li>
                <Link to="/guias" className="text-muted-foreground hover:text-foreground">
                  Guías de Compra
                </Link>
              </li>
              <li>
                <Link to="/como-elegir" className="text-muted-foreground hover:text-foreground">
                  Cómo Elegir tu Silla
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-foreground">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/quiz-sillas" className="text-muted-foreground hover:text-foreground">
                  Quiz de Sillas
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="mb-4 font-display text-sm font-semibold">Legal</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/sobre-nosotros" className="text-muted-foreground hover:text-foreground">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="text-muted-foreground hover:text-foreground">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/aviso-legal" className="text-muted-foreground hover:text-foreground">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/afiliados" className="text-muted-foreground hover:text-foreground">
                  Programa de Afiliados
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 border-t border-border pt-8">
          <div className="flex flex-col items-center justify-between gap-4 text-center text-sm text-muted-foreground md:flex-row md:text-left">
            <p>© {currentYear} Silla Ideal. Todos los derechos reservados.</p>
            <p className="text-xs">
              Como afiliados de Amazon, ganamos comisiones por compras elegibles.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
